export function uiClass(defaultClass, unstyled, className) {
    const value = [unstyled ? undefined : defaultClass, className].filter(Boolean).join(" ");
    return value || undefined;
}
export function themeAttribute(theme) {
    return theme === "system" ? undefined : theme;
}
//# sourceMappingURL=appearance.js.map